import { supabase } from '@/core/database/supabase';
import type { LaborRate, LaborRateFilters } from '../types/laborRates.types';

export const LaborRatesService = {
  async getLaborRates(companyId: string, filters: LaborRateFilters = {}) {
    let query = supabase
      .from('user_labor_rates')
      .select('*, user_profiles(full_name, user_code, job_title)', { count: 'exact' })
      .eq('company_id', companyId);

    if (filters.rate_type && filters.rate_type !== 'all') {
      query = query.eq('rate_type', filters.rate_type);
    }
    
    // Search requires filtering via the relation or client-side. Supabase postgrest doesn't easily ilike on joined tables without inner join notation.
    if (filters.search) {
      query = query.not('user_profiles', 'is', null).or(`full_name.ilike.%${filters.search}%,user_code.ilike.%${filters.search}%`, { foreignTable: 'user_profiles' });
    }

    const { data, error, count } = await query.order('effective_from', { ascending: false });

    if (error) throw error;
    return { data: data as LaborRate[], total: count || 0 };
  },

  async getUserLaborRates(userId: string): Promise<LaborRate[]> {
    const { data, error } = await supabase
      .from('user_labor_rates')
      .select('*')
      .eq('user_id', userId)
      .order('effective_from', { ascending: false });

    if (error) throw error;
    return data as LaborRate[];
  },

  async createLaborRate(rate: Partial<LaborRate>) {
    const { data, error } = await supabase
      .from('user_labor_rates')
      .insert(rate)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async updateLaborRate(id: string, updates: Partial<LaborRate>) {
    const { data, error } = await supabase
      .from('user_labor_rates')
      .update(updates)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async deleteLaborRate(id: string) {
    const { error } = await supabase
      .from('user_labor_rates')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
